import React, { useCallback } from "react";
import PropTypes from "prop-types";
import FormControlTemplate from "../ui/formControlTemplate/FormControlTemplate";

const Label = React.lazy(() => import("../ui/label/Label"));
const TextArea = React.lazy(() => import("../ui/inputs/textArea/TextArea"));
const ValidationText = React.lazy(() =>
  import("../ui/validation/ValidationText")
);

const FormTextAreaFields = ({
  keyId,
  dataField,
  labelName,
  name,
  type,
  value,
  error,
  formSetting = {},
  isRequired,
  fieldSetting = {},
  onChange,
  onActionChange,
  onBlure,
  overRideProps,
  verticalRows,
  ...otherProps
}) => {
  const handleInputChange = useCallback(
    (value) => {
      onChange?.(dataField, value);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [onChange, dataField]
  );

  const handleOnBlur = () => {
    onBlure?.(dataField);
  };

  const handleButtonClick = (action) => {
    onActionChange?.(action, dataField);
  };

  return (
    <div className="input-field-sec" key={keyId}>
      {fieldSetting.subTitle && (
        <div className="section-title">
          <h5>{fieldSetting.subTitle}</h5>
        </div>
      )}
      <div className={`input-label-part ${verticalRows ? "vertical-rows" : ""}`}>
        {labelName && (
          <Label labelName={labelName} htmlFor={name} isRequired={isRequired} />
        )}
        <div className="text-area-input-wrapper">
          <TextArea
            {...fieldSetting}
            id={name}
            keyId={keyId}
            name={name}
            type={type}
            value={value}
            onChange={handleInputChange}
            onBlur={handleOnBlur}
            showCharacterLength={fieldSetting.showCharacterLength}
            isdisable={
              formSetting?.isViewOnly ||
              (overRideProps?.isDisable !== undefined
                ? overRideProps?.isDisable
                : fieldSetting?.isDisable) ||
              false
            }
            isreadonly={
              formSetting?.isReadOnly ||
              (overRideProps?.isReadOnly !== undefined
                ? overRideProps?.isReadOnly
                : fieldSetting?.isReadOnly) ||
              false
            }
            readOnly={fieldSetting.isReadOnly}
            {...otherProps}
          />
          {fieldSetting?.isFormControl && (
            <FormControlTemplate
              fieldSetting={fieldSetting}
              handleButtonClick={handleButtonClick}
            />
          )}
          <ValidationText error={error || ""} />
        </div>
      </div>
    </div>
  );
};

FormTextAreaFields.propTypes = {
  keyId: PropTypes.string,
  dataField: PropTypes.string.isRequired,
  labelName: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  formSetting: PropTypes.shape({
    isViewOnly: PropTypes.bool,
  }),
  verticalRows: PropTypes.bool,
  isRequired: PropTypes.bool,
  fieldSetting: PropTypes.shape({
    debounceTime: PropTypes.number,
    isDisable: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    isFormControl: PropTypes.bool,
    subTitle: PropTypes.string,
    showCharacterLength: PropTypes.bool,
  }),
  overRideProps: PropTypes.shape({
    isDisable: PropTypes.bool,
    isReadOnly: PropTypes.bool,
  }),
  onChange: PropTypes.func,
  onActionChange: PropTypes.func,
  onBlure: PropTypes.func,
};

export default FormTextAreaFields;
